import { DashboardComponent } from './dashboard/dashboard.component';
import { NgModule }             from '@angular/core';
import { RouterModule, Routes, Router, NavigationEnd } from '@angular/router';
import { EditionResolve } from './editions/edition-resolve';
import { PermissionsRouteGuard, AuthenticationInitializedGuard } from './app-guards';
import { UnauthorizedComponent } from './global-user/unauthorized/unauthorized.component';

export const routes: Routes = [
  {path: '', canActivateChild: [PermissionsRouteGuard, AuthenticationInitializedGuard], children: [
    {
      path: '',
      redirectTo: 'dashboard',
      pathMatch: 'full',
    },
    {
      path: 'dashboard',
      // This is not actually being lazy loaded, still being imported in app module which means eager loading
      loadChildren: './dashboard/dashboard.module#DashboardModule',
      resolve: {
        edition: EditionResolve // this ensures that Edition and EditionMap are available
      },
      data: {
        requiredRole: 'dashboard'
      }
    },
    {
      path: 'global-settings',
      // This is not actually being lazy loaded, still being imported in app module which means eager loading
      loadChildren: './global-settings/global-settings.module#GlobalSettingsModule',
      resolve: {
        edition: EditionResolve
      },
      data: {
        requiredRole: 'grantEditionAdmin'
      }
    },
    {
      path: 'content-library',
      loadChildren: './content-library/content-library.module#ContentLibraryModule',
      resolve: {
        edition: EditionResolve
      },
      data: {
        requiredRole: 'editionAdministration'
      }
    },
    {
      path: 'analytics',
      loadChildren: './analytics/analytics.module#AnalyticsModule',
      resolve: {
        edition: EditionResolve
      },
      data: {
        requiredRole: 'analyticsAccess'
      }
    },
    {
      path: 'editions',
      // This is not actually being lazy loaded, still being imported in app module which means eager loading
      loadChildren: './editions/editions.module#EditionsModule',
      data: {
        requiredRole: 'anyAdminOrAnalytics'
      }
    },
    {
      path: 'subscriptions',
      // This is not actually being lazy loaded, still being imported in app module which means eager loading
      loadChildren: './subscriptions/subscriptions.module#SubscriptionsModule',
      data: {
        requiredRole: 'listSubscriptions'
      }
    },
    {
      path: 'unauthorized',
      component: UnauthorizedComponent,
      data: {
        requiredRole: 'anyAdminOrAnalytics'
      }
    }
  ]}
];

@NgModule({
    imports: [ RouterModule.forRoot(routes) ],
    exports: [ RouterModule ],
    providers: [
      PermissionsRouteGuard,
      EditionResolve,
      AuthenticationInitializedGuard,
    ]
})

export class AppRoutingModule {
  constructor(private router: Router) {
    this.router.events.subscribe(event  => {
      if (event instanceof NavigationEnd) {
        window.scroll(0, 0);
      }
    });
  }
}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/app-routing.module.ts